import {Box} from "@mui/material";
import {theme} from "../../../../../_fri/themes/theme";
import {
    CustomItemDetailShoppingCart
} from "../../../../../_fri/components/CustomItemDetailShoppingCart/CustomItemDetailShoppingCart";
import KitchenRoundedIcon from '@mui/icons-material/KitchenRounded';
import DesktopWindowsRoundedIcon from '@mui/icons-material/DesktopWindowsRounded';

export const EcommerceDashboardDetailHeader = () => {
    return (
        <Box sx={{
            border: `1px ${theme.palette.common.black} solid`,
            borderRadius: "1.8rem",
            padding: "1.8rem",
            margin: "2rem",
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            marginBottom: "1rem"
        }}>

            <Box sx={{fontSize:"1.5rem", marginBottom:"1rem"}}>
                Detalle de compra #145
            </Box>

            <Box sx={{fontSize:"1rem", fontWeight:theme.typography.fontWeightLight, marginBottom:"1rem"}}>
                Confirma los productos del cliente:
            </Box>

            <Box>
                <CustomItemDetailShoppingCart name={'Televisor Led'} price={'400.00'} quantity={'1'} iconAvatar={ <DesktopWindowsRoundedIcon sx={{fontSize:"2rem"}}/>}/>

                <hr style={{marginTop:"1rem", marginBottom:"1rem", borderTop:"dashed 1px"}}/>

                <CustomItemDetailShoppingCart name={'Estufa a gas'} price={'200.00'} quantity={'1'} iconAvatar={ <KitchenRoundedIcon sx={{fontSize:"2rem"}}/>}/>

            </Box>

        </Box>
    );
};